export default {
  isFranchiseClinic: state => state.isFranchiseClinic,
  isDoctorClinic: state =>
    state.AppActiveUser.userRole === 'doctorClinic' ? true : false,
};
